module.exports = __webpack_public_path__ + "static/media/Prenotazione_biglietti_treni.9da65078.png";